import { Helmet } from 'react-helmet-async';
import { Container, Typography } from '@mui/material';
import JoinForm from 'src/components/form/JoinForm';
import { t } from 'i18next';

const JoinPage = () => {
  return (
    <Container
      maxWidth="md"
      sx={{
        minHeight: '100vh',
        mt: { md: 0, xs: 10 },
        pb: 2,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <Helmet>
        <title>JMC</title>
      </Helmet>
      <Typography sx={{ mb: 3, textAlign: 'center' }} variant="h4" color={'primary'}>
        {t('joinPage.heading')}
      </Typography>
      <JoinForm />
    </Container>
  );
};

export default JoinPage;
